import React, { Dispatch, SetStateAction, useState } from 'react';
import { Link } from 'react-router-dom';
import { credentialImageURL, formatEarnedOnDate } from '../../hooks/helpers';
import { DiscoverCredentialsModal } from '../DiscoverCredentialsModal';
import { IBLSpinLoader } from '../IBLSpinLoader';
import './CredentialLayoutBox.css';
import { ICredential } from '../../model';
import { inIframe } from '../../utils';
import { useTranslation } from 'react-i18next';
import ReactPaginate from 'react-paginate';

interface CredentialLayoutBoxProps {
  userCredentials: ICredential[];
  userCredentialsLoaded: boolean;
  userCredentialTotalPages: number;
  discoverCredentials: ICredential[];
  discoverCredentialsLoaded: boolean;
  searchTerm?: string;
  userName: string;
  userCredentialPage: number;
  paginate: (selectedItem: { selected: number }) => void;
  setCredentialsCount?: Dispatch<SetStateAction<number>>;
}

export const CredentialLayoutBox: React.FC<CredentialLayoutBoxProps> = ({
  userCredentials = [],
  userCredentialsLoaded,
  userCredentialTotalPages,
  discoverCredentials,
  discoverCredentialsLoaded,
  searchTerm = '',
  userName,
  userCredentialPage,
  paginate,
  setCredentialsCount
}) => {
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const { t } = useTranslation('library');

  const filteredCredentials = userCredentials.filter((credential) =>
    credential?.credentialDetails?.name
      ?.toLowerCase()
      .includes(searchTerm.toLowerCase())
  );

  setCredentialsCount?.(filteredCredentials.length || 0);
  

  const renderCredentialLinks = () => {
    if (filteredCredentials?.length === 0 && inIframe()) {
      return <></>;
    }

    return (
      <>
        {filteredCredentials.map((credential, index) => (
          <Link
            key={index}
            to={`/profile/credentials/${credential.entityId}`}
            className="cr_link_box w-inline-block"
          >
            <div className="cr_box">
              <div className="cr_box_flex">
                <img
                  alt=""
                  className="image-153"
                  src={credentialImageURL(credential)}
                  onError={(e) =>
                    (e.currentTarget.src = '/images/default_badge.png')
                  }
                />
                <div>
                  <div className="text-block-232">
                    {credential.credentialDetails.name}
                  </div>
                  <div className="text-block-239">
                    {credential.credentialDetails.issuerDetails.name}
                  </div>
                  <div className="text-block-239 date">
                    {t('Earned on')}: {formatEarnedOnDate(credential.issuedOn)}
                  </div>
                </div>
              </div>
            </div>
          </Link>
        ))}
      </>
    );
  };

  return (
    <>
      <style
        dangerouslySetInnerHTML={{
          __html:
            '\n\n                ul {\n                list-style: none;\n            }\n\n                .pagination {\n               display: flex;\n    justify-content: flex-end;\n  margin-top: 12px;\n          }\n\n                .pagination .page-number {\n               padding: 2px 10px;\n    border-radius: 4px;\n    font-size: 14px;\n    cursor: pointer;\n    margin: 0 4px;\n    align-items: center;\n    justify-content: center;\n            }\n\n                .pagination .page-number:hover {\n                background-image: linear-gradient(90deg, #4a78b8, #6cafe1);\n    color: #fff;\n            }\n\n                .pagination .active {\n               background-image: linear-gradient(90deg, #4a78b8, #6cafe1);\n    color: #fff;\n            }\n\n                .pagination .active:hover {\n                color: #00a8ff;\n                background: #fff;\n            }\n            ',
        }}
      />
      {userCredentialsLoaded ? (
        <>
          <div className="sk_cont">
            <div className="cr_row pp">
              {!inIframe() && (
                <div
                  prop-events-value-onclick="handleCreatePathwayClick"
                  no-mapping=""
                  prop-events-names="onClick"
                  id="w-node-_617ef0ca-81f8-84cc-a337-8b500ce207cc-7c5fe5ef"
                  className="item-box path_box"
                >
                  <Link to="/discover" className="link-block-31 w-inline-block">
                    <div className="div-block-444 credentials_box">
                      <div className="div-block-394">
                        <img
                          src="https://assets-global.website-files.com/6596e21ac435cac3c66baad8/6596e21ac435cac3c66babee_plus.png"
                          loading="lazy"
                          alt=""
                          className="image-142"
                        />
                      </div>
                      <div className="c_p">{t('Discover Credentials')}</div>
                    </div>
                  </Link>
                </div>
              )}

              {renderCredentialLinks()}
            </div>
            {/*{!userCredentials.length && (
              <NoItemView displayMessage="You haven't earned any credentials yet." imageUrl="/images/tools.png" />
            )}*/}
            {userCredentialTotalPages > 1 && (
              <ReactPaginate
                onPageChange={paginate}
                pageCount={userCredentialTotalPages}
                previousLabel={'Prev'}
                nextLabel={'Next'}
                containerClassName={'pagination'}
                pageLinkClassName={'page-number'}
                previousLinkClassName={'page-number'}
                nextLinkClassName={'page-number'}
                activeLinkClassName={'active'}
                forcePage={userCredentialPage - 1}
              />
            )}
          </div>
          {isPopupOpen && (
            <DiscoverCredentialsModal
              closePopUp={() => setIsPopupOpen(false)}
              discoverCredentials={discoverCredentials}
            />
          )}
        </>
      ) : (
        <IBLSpinLoader size={40} containerHeight="150px" />
      )}
    </>
  );
};
